module.exports = __webpack_public_path__ + "img/clear.762c08a5.png";